import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import { getConfig } from '@edx/frontend-platform';

export const fetchNotesForCourse = async (courseId) => {
  const url = `${getConfig().LMS_BASE_URL}/courses/${courseId}/edxnotes/notes/`;
  const { data } = await getAuthenticatedHttpClient().get(url);
  return data;
};

export const fetchAllNotes = async (courseIds) => {
  const results = await Promise.allSettled(
    courseIds.map((courseId) => fetchNotesForCourse(courseId)),
  );

  const allNotes = [];
  results.forEach((result) => {
    if (result.status === 'fulfilled') {
      const notes = result.value?.results || [];
      allNotes.push(...notes);
    }
  });

  allNotes.sort((a, b) => new Date(b.created) - new Date(a.created));
  return allNotes;
};
